import script from "./editable-remark-tags-list.vue?vue&type=script&setup=true&lang=js"
export * from "./editable-remark-tags-list.vue?vue&type=script&setup=true&lang=js"

import "./editable-remark-tags-list.vue?vue&type=style&index=0&id=9168851f&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9168851f"]])

export default __exports__